import { render } from "./ImportDescuentoPersonalizado.vue?vue&type=template&id=60070f0a"
import script from "./ImportDescuentoPersonalizado.vue?vue&type=script&lang=js"
export * from "./ImportDescuentoPersonalizado.vue?vue&type=script&lang=js"

import "./ImportDescuentoPersonalizado.vue?vue&type=style&index=0&id=60070f0a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__